import { z } from 'zod';

export const deleteArticleSchema = z.object({
  article_id: z.uuid('Invalid article ID'),
});

export type DeleteArticlePayload = z.infer<typeof deleteArticleSchema>;
